import { useEffect, useState } from "react";
import { useQuery } from "react-query";

const useUserProfile = () => {
  const [userInfo, setUserInfo] = useState({});
  const [token, setToken] = useState(() => localStorage.getItem("accessToken"));

  const url = `${process.env.REACT_APP_AUTH_API_BASE_URL}/users/my-profile`;

  useEffect(() => {
    const handleAuthChange = () => {
      setToken(localStorage.getItem("accessToken"));
    };

    window.addEventListener("auth-change", handleAuthChange);
    return () => window.removeEventListener("auth-change", handleAuthChange);
  }, []);

  const { data: userData, isLoading: isProfileLoading } = useQuery(
    ["user", token],
    async () => {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Unable to load user profile");
      }

      return response.json();
    },
    { enabled: !!token }
  );

  useEffect(() => {
    if (userData) {
      // console.log(userData);
      setUserInfo(userData?.data);
    }
  }, [userData]);

  return { userInfo, isUserLoading: !!token && isProfileLoading };
};

export default useUserProfile;
